import { ConfirmDuplicateCollectionModal } from './ConfirmDuplicateCollectionModal'

export default ConfirmDuplicateCollectionModal
